import {
  COUNTRIES
} from '../deliveryCardComponent/addressData';

const defaultProps = {
  title: 'Delivery Method',
  error: false,
  errorText: 'Please update your address',
  disabled: false,
  required: true,
  isLoading: false,
  isYourSelf: false,
  onChange: (address: any) => {
    console.log(address);
  },
  handleEdit: () => {console.log('Jump to step')},
  handleChangeCountry: (country: string) => {},
  countryList: [...COUNTRIES],
  defaultCountry: 'usa',
  countryUserLogin: 'mex',
  addressItem: {
    // country: 'mex',
    // uid: '30e3b39c1b6ee1d4a855ba63164bcb21',
    // name: 'GFMS_VN_HoChiMinh', 
    // shipping_address: 'Floor 8th',
  },
  locale: {
    addAddress: 'Add Address',
    addressType: {
      city: 'House number, building or street name, city',
      country: 'Country',
      state: 'State, zip code',
      pickUpLocation: 'Pick up location'
    },
    pickup: 'Pick Up',
    shippingType: {
      label: 'Shipping Type',
      option: {
        delivery: 'Delivery',
        pickUp: 'Pick Up',
      },
      noteText: {
        delivery: 'Delivery - The device will reach you in take  4 - 14 days.',
        pickUp: 'Pick Up - The device will be ready in 5 days.',
      },
      pickUpLocation: 'Pick Up Location',
    },
    countryRegion: 'Country/Region',
    editAddress: 'Edit Address',
    id: '510f796d-8e25-4ed9-aebf-ca9edf6ae340',
    txtCancel: 'CANCEL',
    txtOk: 'OK',
    updateAddress: 'Update Address',
    dataField: {
      label: {
        'Address Line 1': 'Address Line 1',
        'Address Line 2': 'Address Line 2',
        City: 'City',
        State: 'State',
        'Zip Code': 'Zip Code',
        Postcode: 'Postcode',
        Suburb: 'Suburb',
        'State/territory': 'State/territory',
        Region: 'Region',
        'Postal Code': 'Postal Code',
        Province: 'Province',
        'Street and House Number': 'Street and House Number',
        'City/Town': 'City/Town',
        'PIN Code': 'PIN Code',
        Canton: 'Canton',
        Districts: 'Districts',
        'Street Name': 'Street Name',
        'House Number': 'House Number',
        Town: 'Town',
        'Building Information': 'Building Information',
        'Sector/Village': 'Sector/Village',
        'Address 1': 'Address 1',
        'Address 2': 'Address 2',
        Department: 'Department',
        District: 'District',
      },
      placeHolder: {
        'Apartment, suite, etc': 'Apartment, suite, etc. (optional)',
        'Mail box number or Description of house location':
          'Mail box number or Description of house location',
        Optional: 'Optional',
        'Floor/Department/District Information':
          'Floor/Department/District Information',
        'Street name and number': 'Street name and number',
        'Nearest intersecting street': 'Nearest intersecting street',
        'Apartment Building': 'Apartment Building',
        'House number, Street name': 'House number, Street name',
      },
    },
  },
  dataPickupLocation: [
    {
      uid: '1w3eb39c1brth78dcb45ba63164bce45',
      name: 'GFPS_DE_Albershausen',
      shipping_address: 'Next to the bank'
    },
    {
      uid: '30e3b39c1b6ee1d4a855ba63164bcb21',
      name: 'GFMS_VN_HoChiMinh',
      shipping_address: 'Floor 8th'
    }
  ]
};

export default defaultProps;
